import React, { useEffect, useState, useCallback } from "react";
import { ClipboardList, Save } from "lucide-react";
import { Card, Button, Spinner, PageHeader, Select } from "../../lib/ui";
import { useToast } from "../../lib/toast";
import { useAuth } from "../../context/AuthContext";
import api from "../../lib/api";

const FIELDS = [
  ["responsibilities", "Tanggung Jawab"],
  ["daily_tasks", "Tugas Harian"],
  ["weekly_tasks", "Tugas Mingguan"],
  ["monthly_tasks", "Tugas Bulanan"],
];

export default function HRJobdesk() {
  const toast = useToast();
  const { user } = useAuth();
  const canManage = ["SUPER_ADMIN", "OWNER", "HR_MANAGER"].includes(user?.role);
  const [list, setList] = useState([]);
  const [pos, setPos] = useState("");
  const [draft, setDraft] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/hr/jobdesks");
      setList(data.jobdesks);
      const first = data.jobdesks[0];
      setPos((p) => p || first?.position);
    } catch { toast.error("Gagal memuat"); } finally { setLoading(false); }
  }, [toast]);
  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    const jd = list.find((j) => j.position === pos);
    if (jd) setDraft({ ...jd, ...Object.fromEntries(FIELDS.map(([k]) => [k, (jd[k] || []).join("\n")])) });
  }, [pos, list]);

  const save = async () => {
    try {
      const payload = { position: pos, department: draft.department || null };
      FIELDS.forEach(([k]) => { payload[k] = (draft[k] || "").split("\n").map((s) => s.trim()).filter(Boolean); });
      await api.put("/hr/jobdesks", payload);
      toast.success("Jobdesk tersimpan"); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); }
  };

  return (
    <div data-testid="hr-jobdesk-page">
      <PageHeader title="Jobdesk Management" subtitle="Definisikan tanggung jawab & tugas per posisi" icon={ClipboardList}>
        <Select value={pos} onChange={(e) => setPos(e.target.value)} data-testid="hr-jobdesk-position" className="!w-44">
          {list.map((j) => <option key={j.position} value={j.position}>{j.position}</option>)}
        </Select>
      </PageHeader>

      {loading || !draft ? <div className="flex h-64 items-center justify-center"><Spinner className="h-8 w-8" /></div> : (
        <Card data-testid="hr-jobdesk-editor">
          <div className="grid gap-4 sm:grid-cols-2">
            {FIELDS.map(([k, label]) => (
              <div key={k}>
                <label className="cf-label">{label} <span className="text-ink-mute">(satu per baris)</span></label>
                <textarea className="cf-input min-h-[120px]" value={draft[k]} disabled={!canManage}
                  onChange={(e) => setDraft({ ...draft, [k]: e.target.value })} data-testid={`hr-jobdesk-${k}`} />
              </div>
            ))}
          </div>
          {canManage && <div className="mt-4"><Button onClick={save} data-testid="hr-jobdesk-save"><Save size={15} /> Simpan Jobdesk</Button></div>}
        </Card>
      )}
    </div>
  );
}
